import axios from 'axios';

const viacepRequest = axios.create({
  baseURL: import.meta.env.REACT_APP_VIACEP_URL,
});

export default viacepRequest;
